import React from 'react';

const containerStyle = {
  textAlign: 'center',
  marginTop: '40px', // Matches original fallback style
};

export default function LoadingSpinner() {
  return (
    <div style={containerStyle}>
      <div className="loader"></div>
    </div>
  );
}
